<template>
  <header class="header header-container" id="main-header">
    <md-toolbar class="moow-toolbar">
    <!-- <md-toolbar class="md-primary play-toolbar dark"> -->
      <md-button class="md-icon-button" @click="toggleMenu">
        <md-icon v-if="menuVisible">keyboard_arrow_left</md-icon>
        <md-icon v-else>menu</md-icon>
      </md-button>
      <div class="md-toolbar-section-start" v-if="!narrowWidth">
        <b-col style="max-width:200px;">
          <div class="header-logo-holder" :class="{'white':overlay}" @click="navigateHome"></div>
          <!-- <div class="header-logo-holder white" @click="navigateHome"></div> -->
        </b-col>
        <b-col style="max-width:100px;">
          <md-button
            class="md-fab md-mini md-primary play-fab light"
            :class="{'moow-fab-mini':overlay}"
            @click="toggleTutorial()"
          >
            <md-icon>help_outline</md-icon>
            <md-tooltip md-direction="bottom">Information Center</md-tooltip>
          </md-button>
        </b-col>
        <!-- <div v-if="showAddressSearch" class="header-navbar-search">
          <adr-search-bar
            :onPlaceSelected="selectPlace"
            keywordPlaceholder="City"
            :onError="searchError"
            searchType="(cities)"
          ></adr-search-bar>
        </div> -->
      </div>

      <div class="md-toolbar-section-end">
        <b-navbar>
          <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav class="ml-auto mt-auto mo-navbar-dropdown">
              <b-nav-item-dropdown right style="margin-left:30px;">
                <template slot="button-content">
                  <md-icon>translate</md-icon>
                </template>
                <b-dropdown-item @click="setLocale({locale:'et-NL'})">Eesti</b-dropdown-item>
                <b-dropdown-item @click="setLocale({locale:'en-NL'})">English</b-dropdown-item>
                <b-dropdown-item @click="setLocale({locale:'ru-NL'})">Pусский</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-navbar-nav>
                <b-nav-item :to="{name:'listingsearch'}" v-if="loggedIn">MARKET</b-nav-item>
                <b-nav-item :to="{name:'chat'}" v-if="loggedIn" :class="{'white-text':overlay}">
                  CHAT
                  <div v-if="showUnreadMsgBadge" class="mo-badge"></div>
                </b-nav-item>
              </b-navbar-nav>
              <b-nav-item-dropdown right style="margin-left:30px;" v-if="loggedIn">
                <template slot="button-content">
                  <md-avatar class="md-medium cast-shadow">
                    <img :src="userAvatar" alt="A" />
                  </md-avatar>
                </template>
                <b-dropdown-item v-if="loadingUser" style="color:#ec8080;">loading...</b-dropdown-item>
                <b-dropdown-item
                  :to="{name:'settings'}"
                  v-else-if="loggedIn && !userIsVerified"
                  style="color:#ec8080;"
                >{{i18n_local.verify_account | capitalize}}</b-dropdown-item>
                <b-dropdown-item
                  :to="{name:'settings'}"
                  v-if="loggedIn && !loadingUser"
                >{{i18n_local.profile | capitalize}}</b-dropdown-item>
                <b-dropdown-item
                  :to="{name:'account'}"
                  v-if="loggedIn && !loadingUser"
                >{{i18n_local.account | capitalize}}</b-dropdown-item>
                <b-dropdown-item @click="logOut" v-if="loggedIn">{{i18n_local.log_out | capitalize}}</b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </md-toolbar>

    <md-drawer
      class="main-side-nav"
      :md-active.sync="menuVisible"
      :md-persistent="sideNavPresistenceValue"
      md-swipeable
      md-permanent="clipped"
    >
      <div @mouseover="openDrawer()" @mouseleave="closeDrawer()">
        <md-list class="side-cta-nav">
          <md-list-item to="/dashboard" v-if="loggedIn && userViewRoleIsLandlord">
            <md-icon>description</md-icon>
            <span class="md-list-item-text">{{i18n_local.properties | allCaps}}</span>
          </md-list-item>

          <md-list-item to="/deals" v-if="loggedIn && userViewRoleIsLandlord">
            <md-icon>bookmarks</md-icon>
            <span class="md-list-item-text">{{i18n_local.deals | allCaps}}</span>
            <md-tooltip md-direction="bottom">for landlords</md-tooltip>
          </md-list-item>

          <md-list-item to="/stays" v-if="loggedIn && !userViewRoleIsLandlord">
            <md-icon>place</md-icon>
            <span class="md-list-item-text">{{i18n_local.stays | allCaps}}</span>
            <md-tooltip md-direction="bottom">for tenants</md-tooltip>
          </md-list-item>

          <md-list-item to="/calendar" v-if="loggedIn && userViewRoleIsLandlord">
            <md-icon>calendar_today</md-icon>
            <span class="md-list-item-text">{{i18n_local.calendar | allCaps}}</span>
          </md-list-item>

          <md-list-item to="/login" v-if="!loggedIn">
            <md-icon>power_settings_new</md-icon>
            <span class="md-list-item-text">{{i18n_local.log_in | allCaps}}</span>
          </md-list-item>

          <md-list-item to="/register" v-if="!loggedIn">
            <md-icon>account_circle</md-icon>
            <span class="md-list-item-text">{{i18n_local.sign_up | allCaps}}</span>
          </md-list-item>

          <md-divider></md-divider>

          <md-list-item to="/changelog">
            <md-icon>star_border</md-icon>
            <span class="md-list-item-text">{{i18n_local.whats_new}}</span>
          </md-list-item>
        </md-list>
        <div class="view-role-container mt-2" :class="{hidden:!menuVisible}">
          <toggle-switch
            :btnTitleOn="i18n_local.im_landlord"
            :btnTitleOff="i18n_local.im_tenant"
            @emitToggleOn="toggleUserViewRole"
            :initialState="userViewRoleIsLandlord"
          />
        </div>
      </div>
    </md-drawer>

    <md-dialog :md-active.sync="showTutorial" class="moow-vert-scrollbar">
      <md-dialog-title class="moow-header-2">
        <b-row>
          <b-col>{{i18n_local.whats_moowle}}</b-col>
          <b-col style="text-align:right">
            <md-button class="md-icon-button md-dense" @click="showTutorial = false">
              <md-icon>highlight_off</md-icon>
            </md-button>
          </b-col>
        </b-row>
      </md-dialog-title>
      <md-content style="padding:1em;">
        <p class="moow-info-txt">{{i18n_local.moowle_for_landlords_1}}</p>
        <p class="moow-info-txt">{{i18n_local.moowle_for_tenants_1}}</p>

        <md-tabs md-dynamic-height>
          <md-tab md-label="For Landlord">
            <ol class="moow-info-txt">
              <li>Register for free</li>
              <li>Manage Property - edit listing here, changes go to all connected portals automatically.</li>
              <li>Real-time analytics & conversion.</li>
              <li>Booking Requests - chat and offer directly to a vetted tenant using built in chat and other tools.</li>
              <li>Manage Bookings - bookings, contracts, rent, calendar and other details all here in one place.</li>
              <li>Receive Rent - receivce, don't collect as payments are automated!</li>
            </ol>
          </md-tab>

          <md-tab md-label="For Tenant">
            <ol class="moow-info-txt">
              <li>Register for free</li>
              <li>Shop for Listing - you can find the same listings here as well as on on all the major portals.</li>
              <li>Connect to Landlord - chat and get custom offers from the owner directly.</li>
              <li>Book the Place - book the stay right in the same chat with the sweet custom deal.</li>
              <li>Manage Your Stay - pay for rent, enjoy automatic contracts and other information.</li>
              <li>Stay in Touch - your landlord is always a click away.</li>
            </ol>
          </md-tab>
        </md-tabs>

        <md-divider class="moow-divider"></md-divider>

        <b-row>
          <b-col>
            <p>+372 5366 6903 • moowle@moowle.com</p>
            <p>EDMI Group OÜ • Pärnu mnt 148, Tallinn</p>
          </b-col>
          <b-col>
            <p class="moow-info-txt">
              <a href="https://moowle.com/terms-of-use/" target="_blank">Terms of use</a>
            </p>
            <p class="moow-info-txt">
              <a href="https://moowle.com/privacy-policy/" target="_blank">Privacy Policy</a>
            </p>
          </b-col>
        </b-row>
      </md-content>
      <md-dialog-actions>
        <md-button
          class="md-raised md-primary play-cta-button-flat makeup"
          style="text-decoration:none"
          @click="showContactForm=true"
        >{{i18n_local.contact_sales}}</md-button>
        <md-button
          class="md-raised md-primary play-cta-button makeup"
          style="text-decoration:none"
          @click="showSupportForm=true"
        >{{i18n_local.support}}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="showContactForm">
      <contact-form @closeForm="closeContactUsForm"></contact-form>
    </md-dialog>

    <md-dialog :md-active.sync="showSupportForm">
      <support-form
        @emitFinish="finishedSupportForm"
        inputSubjectTitle="Subject"
        inputContentTitle="Describe the question or problem"
      ></support-form>
    </md-dialog>

    <md-snackbar :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
    </md-snackbar>
  </header>
</template>

<script>
import ContactUsForm from "../../components/dialogs/ContactUsForm.vue";
import SupportForm from "../../components/dialogs/SupportForm";
import AddressSearchBar from "../../components/adrSearchBar.vue";
import ToggleSwitch from "@/components/interface/buttons/toggleSwitch.vue";
import { getUserUid } from "../../functions.js";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  props: {
    showAddressSearch: {
      type: Boolean,
      default: true
    },
    overlay: {
      type: Boolean,
      default: false
    }
  },
  components: {
    "contact-form": ContactUsForm,
    "adr-search-bar": AddressSearchBar,
    "support-form": SupportForm,
    "toggle-switch": ToggleSwitch
  },
  data() {
    return {
      sideNavPresistenceValue: "mini",
      narrowWidth: false,
      showNavigation: false,
      menuVisible: false,
      showTutorial: false,
      showContactForm: false,
      showSnackbar: false,
      snackbarMessage: "",
      showSupportForm: false
    };
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    allCaps: function(value) {
      return value.toUpperCase();
    }
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    userAvatar() {
      if(this.$store.getters.user.pictureUrl) return this.$store.getters.user.pictureUrl
      return require("../../assets/owl_round_back.png");
    },
    loggedIn() {
      return this.$store.getters.isUserLoggedIn;
    },
    tenantFlow() {
      return require("../../assets/tenant-flow.png");
    },
    landlordFlow() {
      return require("../../assets/landlord-flow.png");
    },
    showUnreadMsgBadge() {
      return this.$store.getters.showUnreadMsgBadge;
    },
    userIsVerified() {
      return this.$store.getters.isUserVerified;
    },
    loadingUser() {
      return this.$store.getters.loadingUser;
    },
    userViewRoleIsLandlord() {
      return this.$store.getters.userViewRole == "landlord";
    }
  },
  created() {
    window.addEventListener("resize", this.handleWindowResize);
    this.handleWindowResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
  },
  methods: {
    ...mapActions("internationalizationModule", ["setLocale"]),
    toggleUserViewRole(isLandlord) {
      var role;
      isLandlord ? (role = "landlord") : (role = "tenant");
      this.$store.dispatch("editUserViewRole", role);
      isLandlord?this.navigateTo("dashboard"):this.navigateTo("stays");
    },
    finishedSupportForm(isSuccess) {
      this.showSupportForm = false;
      if (isSuccess == false)
        this.notifyUser("Something is not right, contact support@moowle.com");
      if (isSuccess == true)
        this.notifyUser("Ticket submitted. We will be in touch promptly");
    },
    openDrawer() {
      this.menuVisible = true;
    },
    closeDrawer() {
      this.menuVisible = false;
    },
    closeContactUsForm(isSuccess) {
      this.showContactForm = false;
      if (isSuccess == false)
        this.notifyUser("Something is not right, contact support@moowle.com");
      if (isSuccess == true)
        this.notifyUser("Thank You. We will be in touch promptly");
    },
    notifyUser(msg) {
      this.snackbarMessage = msg;
      this.showSnackbar = true;
    },
    toggleTutorial() {
      this.showTutorial = true;
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    handleWindowResize() {
      if (window.innerWidth <= 700) {
        this.narrowWidth = true;
        this.sideNavPresistenceValue = "";
      } else {
        this.narrowWidth = false;
        this.sideNavPresistenceValue = "mini";
      }
    },
    searchError(error) {
      this.$notify({
        title: "Something is not right",
        message: "Search is not working"
      });
    },
    selectPlace(googPrediction) {
      var selectedPlace = googPrediction.description;
      var placeId = googPrediction.place_id;
      var filterMuni = "";
      try {
        var filterMuni = googPrediction.structured_formatting.main_text;
      } catch (err) {}
      this.$router.push({
        name: "listingsearch",
        query: { autoq: "true", muni: filterMuni }
      });
    },
    navigateHome() {
      this.navigateTo("listingsearch")
    },
    navigateTo(where, params) {
      this.$router.push({
        name: where,
        params: params
      });
    },
    logOut() {
      this.navigateHome();
      this.$store.dispatch("logout");
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";

.side-cta-nav .md-icon {
  color: #414042;
}

.router-link-active .md-icon {
  color: #F76765 !important;
}

.overlay-toolbar {
  position: absolute;
  background-color: transparent;
  width: 100%;
  box-shadow: none;
}

.moow-toolbar {
  height: 8vh;
  background-color: white;
  box-shadow: 0 0px 4px -1px rgba(0, 0, 0, 0.2), 0 0px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.main-side-nav {
  position: absolute !important;
  top: 8vh;
  /* background: transparent; */
  border: none !important;
  border-radius: 0px 8px 8px 0px;
  z-index: 999;
}



.mo-navbar-dropdown a {
  text-decoration: none;
}

.header-navbar-logo {
  margin-right: 2em;
}

.header-navbar-search {
  border: 1.2px solid #e2dede;
  border-radius: 20px;
  padding-right: 5px;
  padding-left: 5px;
  margin-left: 2em;
}

.active {
  border-bottom: 2px solid #1f8efa;
  color: black !important;
}

#nav_collapse {
  line-height: 45px;
}

.dropdown-item a {
  text-decoration: none;
}

.dropdown-item {
  outline: none;
}
.view-role-container {
  text-align: center;
  opacity: 1;
  -webkit-transition: opacity 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out;
  -ms-transition: opacity 0.5s ease-in-out;
  -o-transition: opacity 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out;
}

.view-role-container.hidden {
  opacity: 0;
}

/*  from infinity to max 600 and then this kicks in*/
@media (max-width: 600px) {
  .header-navbar-search {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/MainHeader.vue